<section id="treatment" class="content tratamentos">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h3 class="title"><span>Consultas e Exames</span></h3>
                <p>
                    O médico pneumologista é responsável por cuidar da saúde dos pulmões e das vias aéreas. Profissional
                    que te ajuda a respirar melhor e, portanto, viver melhor. 
                </p>
                <p>
                    Através de consultas personalizadas e com atendimento humanizado, o paciente recebe um acompanhamento
                    integral, abrangendo as necessidades físicas e emocionais, para que o objetivo de melhorar a saúde
                    respiratória seja atingido.
                </p>

                <p>
                    Saiba os diversos tratamentos que o médico pneumologista realiza: Sintomas e sequelas pós-covid, asma, DPOC/enfisema pulmonar, tosse
                    crônica, fibrose pulmonar, embolia pulmonar, hipertensão Pulmonar, tuberculose, pneumonia, infecções
                    de vias aéreas, rinite e sinusite, avaliação pulmonar pré-operatória, tabagismo, ronco e apneia do
                    sono, câncer de pulmão, nódulos pulmonares, bronquiectasias, doenças intersticiais
                </p>
                <p>
                    Realização de Espirometria com prova broncodilatadora
                </p>


                <!-- <p>
                    O médico pneumologista é responsável por cuidar da saúde dos pulmões e das vias aéreas. .
                </p>
                <p>
                    Tratamentos diversos como: Sintomas e sequelas pós-covid, asma, DPOC/enfisema pulmonar, tosse
                    crônica, fibrose pulmonar, embolia pulmonar, hipertensão Pulmonar, tuberculose, pneumonia, infecções
                    de vias aéreas, rinite e sinusite, avaliação pulmonar pré-operatória, tabagismo, ronco e apneia do
                    sono, câncer de pulmão, nódulos pulmonares, bronquiectasias, doenças intersticiais
                </p>
                <p>
                    Realização de Espirometria com prova broncodilatadora
                </p>
                <p>
                    Consultas personalizadas, com atendimento humanizado centrado no paciente, visando uma abordagem
                    integral, abrangendo as necessidades físicas e emocionais, para que o objetivo de melhorar a saúde
                    respiratória seja atingido.
                </p> -->
                <app-carousel></app-carousel>
            </div>
        </div>
    </div>
</section>